import { logger } from 'src/commons/utils/logger';
import { AjaxRequestPublisher } from 'src/commons/utils/metrics';
import {
  NETWORK_ERROR_REGEX,
  REQUEST_ERROR_REGEX,
  USER_ABORTED_REQUEST_ERROR,
} from './constants';

type HandleErrorProps = {
  // `unknown`, not `Error`: fetch-request forwards whatever `fetch` rejected
  // with, so a non-Error value has to be handled rather than assumed away.
  error: unknown;
  loggerMessage: string;
  metricSlug: string;
};

const logError = ({ error, loggerMessage, metricSlug }: HandleErrorProps) => {
  // Pass the Error itself so KatalLogger records its name, message and stack.
  // Stringifying a wrapper object here used to log the literal
  // "[object Object]" and discard all three.
  if (error instanceof Error) {
    logger.error(loggerMessage, error);
  } else {
    // KatalLogger spreads a non-Error second argument into the record's
    // context. Wrapping the value in `new Error()` would invent a stack
    // pointing here.
    logger.error(loggerMessage, { error: String(error) });
  }

  const errorMessage = error instanceof Error ? error.message : String(error);
  if (NETWORK_ERROR_REGEX.test(errorMessage)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:networkFailure`,
      1,
    );
  } else if (REQUEST_ERROR_REGEX.test(errorMessage)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:requestAborted`,
      1,
    );
  } else if (USER_ABORTED_REQUEST_ERROR.test(errorMessage)) {
    AjaxRequestPublisher.publishCounterMonitor(
      `${metricSlug}:userAbortedRequest`,
      1,
    );
  }
};

export default logError;
